export enum RouteSegment {
  Root = '',
  MultiSiteDashboard = 'multi-site-dashboard',
  Kiosk = 'kiosk',
  MobileKiosk = 'kiosk-mobile',
  KioskNew = 'kiosk-new',
  KioskTv = 'kiosk-tv',
  Sites = 'sites',
  Overview = 'overview',
  Vehicles = 'vehicles',
  Chargers = 'chargers',
  Graph = 'graph',
  Analytics = 'analytics',
  IdTags = 'id-tags',
  Schedule = 'schedule',
  ChargerDetails = 'charger-details',
  Alerting = 'alerting',
  AiInsights = 'ai-insights',
  Reports = 'reports',
  Roaming = 'roaming',
  Discovery = 'discovery',
  Planning = 'planning',
  Sharing = 'sharing',
  Enablement = 'enablement',
  Pricing = 'pricing',
  Flexibility = 'flexibility',
  Summary = 'summary',
  DrillDown = 'drill-down',
  Units = 'units',
  Awards = 'awards',
  Dispatches = 'dispatches',
  ChargerSessions = 'sessions',
  LiveIssues = 'live-issues',
  InfrastructureHealth = 'infrastructure-health',
  WorkflowManagement = 'workflow',
  DataFlows = 'data-flows',
  Preferences = 'preferences',
  Settings = 'settings',
  Users = 'users',
  AuditLogs = 'audit-logs',
  Trip = 'trip',
  Configuration = 'configuration',
  HealthDiagnostics = 'health-diagnostics',
  PredictiveInfrastructure = 'predictive-infrastructure',
  ChargersDrillDown = 'charger',
  Fleet = 'fleet',
  SessionsOverview = 'sessions',
  SessionAnalytics = 'session-analytics',
  FaultAnalytics = 'fault-analytics',
  Issues = 'issues',
  DepartureSoc = 'departure-soc',
  EnergyTrading = 'energy-trading',
  FlexibilityForecast = 'flexibility-forecast',
  EvUsageForecast = 'ev-usage-forecast',
  ArrivalTimes = 'arrival-times',
  FastSlowCurve = 'fast-slow-curve',
  EvseForecast = 'evse-forecast',
  Baseline = 'baseline',
  SetpointsTradingFlags = 'setpoints-trading-flags',
  GspHarmonisation = 'gsp-harmonisation',
  SmallBess = 'small-bess',
  SupplyVolume = 'supply-volume',
  ExpectedVolume = 'expected-volume',
  DayAheadTrades = 'day-ahead-trades',
  TradingKnobs = 'trading-knobs',
  CalculationSettings = 'calculation-settings',
  BaselineAdjustment = 'baseline-adjustment',
}
